<template>
    <div>
        <el-dialog width="500px" title="图片裁剪" :visible.sync="visible" append-to-body :close-on-click-modal="false"
            class="dialog-container">
            <div v-loading="loading">
                <div class="body">
                    <div class="cropp-content container">
                        <div class="bg-white">
                            <div class="cropper-cont">
                                <vue-cropper ref="cropper" :img="option.img" :outputSize="option.size"
                                    :outputType="option.outputType" :info="true" :full="option.full"
                                    :canMove="option.canMove" :canMoveBox="option.canMoveBox" :fixedBox="option.fixedBox"
                                    :original="option.original" :autoCrop="option.autoCrop"
                                    :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"
                                    :centerBox="option.centerBox" :high="option.high" :infoTrue="option.infoTrue"
                                    @realTime="realTime" @imgLoad="imgLoad" @cropMoving="cropMoving"
                                    :enlarge="option.enlarge"></vue-cropper>
                            </div>

                            <div class="pre mt8">
                                <section class="pre-item">
                                    <div :style="previewStyle2">
                                        <div :style="previews.div">
                                            <img :src="previews.url" :style="previews.img" />
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div class="test-button mt8">
                            <el-button type="primary" @click="finish('blob')">
                                <label class="btn">保存</label>
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { VueCropper } from 'vue-cropper';
export default {
    components: { VueCropper },
    watch: {

    },
    data() {
        return {
            visible: false,
            loading: false,
            model: false,
            modelSrc: '',
            previews: {},
            option: {
                img: '', //裁剪图片的地址 默认空，可选值url地址, base64, blob
                outputSize: 0.8, //裁剪生成图片的质量 默认1 可选0.1 ~ 1
                outputType: 'image/jpg,image/png', //裁剪生成图片的格式 jpg (jpg 需要传入jpeg) 可选：jpeg, png, webp
                info: true, //裁剪框的大小信息 默认：true
                canScale: false, //图片是否允许滚轮缩放
                autoCrop: true, //是否默认生成截图框
                // autoCropWidth: 80%, //默认生成截图框宽度 默认：80% 可选：0-max
                //autoCropHeight: 80%, //默认生成截图框高度 默认：80% 可选：0-max
                fixed: true, //是否开启截图框宽高固定比例
                fixedNumber: [1, 1], //截图框的宽高比例 [1, 1]-[ 宽度 , 高度 ]
                full: true, //是否输出原图比例的截图
                fixedBox: false, //固定截图框大小 默认不允许改变 可选：false
                //canMove: true,//上传图片是否可以移动
                canMoveBox: false, //截图框能否拖动
                original: false, //上传图片按照原始比例渲染
                canterBox: false, //截图框是否被限制在图片里面
                //high: true,//是否按照设备的dpr 输出等比例图片
                infoTrue: true //true 为展示真实输出图片宽高 false 展示看到的截图框宽高
                // maxImgSize: 2000 //限制图片最大宽度和高度 可选：0 ~ max
                //enlarge: 1, //图片根据截图框输出比例倍数 默认1 可选：0 ~ max(建议不要太大不然会卡死的呢)
                //mode: contain //contain , cover, 100px, 100% auto
            },
            previewStyle2: {}
        };
    },
    methods: {
        //保存
        finish() {
            this.$refs.cropper.getCropBlob((data) => { //获取截图的 blob 数据
                let url = window.URL.createObjectURL(data)
                this.$emit('imgUrlClick', url)
                this.visible = false
            });
        },
        //图片转为base64
        imgBase64(imgUrl) {
            this.loading = true
            if (this.isOnlineImage(imgUrl)) {
                this.setAvatarBase64(imgUrl, (base64) => {
                    this.option.img = base64;
                    this.loading = false
                });
            } else {
                this.option.img = imgUrl;
                this.loading = false
            }
        },
        //判断图片线上还是本地
        isOnlineImage(url) {
            return url.startsWith("http") || url.startsWith("https");
        },
        // 实时预览函数--右侧展示样式
        realTime(data) {
            let previews = data;
            let h = 0.6; //高度固定，不然右侧预览会变形
            this.previewStyle2 = {
                width: previews.w + 'px',
                height: previews.h + 'px',
                overflow: 'hidden',
                margin: '0',
                zoom: h
            };
            this.previews = data;
        },
        setAvatarBase64(src, callback) {
            let _this = this;
            let image = new Image();
            image.src = src + '?v=' + Math.random();
            image.crossOrigin = "*";
            image.onload = function () {
                let base64 = _this.transBase64FromImage(image);
                callback && callback(base64);
            }
        },
        transBase64FromImage(image) {
            let canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            let ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height);
            return canvas.toDataURL("image/png");
        },
        imgLoad(msg) {
            console.log(msg);
        },
        cropMoving(data) {
            this.option.cropData = data;
            console.log(data, 'sadasdasdasd');
        }
    }
};
</script>

<style scoped lang="scss">
.dialog-container {
    .bg-white {
        display: flex;
        justify-content: space-around;
        margin-bottom: 30px;

        .cropper-cont {
            width: 274px;
            height: 274px;
        }

        .pre {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-content: space-around;
        }
    }

    .test-button {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .pre-item {
        padding-right: 20px;
    }
}
</style>


